define(function() {
    var IpsModelCollection = require('civicsBase/ipsModelCollection');
    const favorite_contact_model = require('civicsModels/portal/favorite_contact_model');

    return Backbone.Collection.extend({
        model: favorite_contact_model,

        urlRoot: '/delegate/civics-api/api/portal/favorites/contact',
        url: function () {
            return this.urlRoot;
        },

        initialize: function () {
            this.on('add', this._bindModelEvents, this);
            this.each(this._bindModelEvents, this); 
        },

        _bindModelEvents: function (model) {
            this.listenTo(model, 'change:isEditing', () => {
                if (model.get('isEditing')) {
                    this._activateSingleEdit(model);
                }
            });
        },

        _activateSingleEdit: function (activeModel) {
            this.each((model) => {
                if (model !== activeModel) {
                    model.set({
                        isEditing: false,
                        disabled: true
                    });
                } else {
                    model.set({
                        isEditing: true,
                        disabled: false
                    });
                }
            });
        },

        resetEditStates: function () {
            this.each((model) => {
                model.set({
                    isEditing: false,
                    disabled: false
                });
            });
        }
    });
});